import { application } from "./application"

console.log("Controllers index.js is loading...")
console.log("Stimulus application:", application)

import AccountSwitcherController from "./account_switcher_controller"
application.register("account-switcher", AccountSwitcherController)

import AddCheckedEntryController from "./add_checked_entry_controller"
application.register("add-checked-entry", AddCheckedEntryController)

import BudgetActionsController from "./budget_actions_controller"
application.register("budget-actions", BudgetActionsController)

import DueActionsController from "./due_actions_controller"
application.register("due-actions", DueActionsController)

import EntryActionsController from "./entry_actions_controller"
application.register("entry-actions", EntryActionsController)

import FinanceController from "./finance_controller"
application.register("finance", FinanceController)

import GroupDateEditorController from "./group_date_editor_controller"
application.register("group-date-editor", GroupDateEditorController)

import InlineDateEditorController from "./inline_date_editor_controller"
application.register("inline-date-editor", InlineDateEditorController)

import InlineBudgetEditorController from "./inline_budget_editor_controller"
application.register("inline-budget-editor", InlineBudgetEditorController)

import InlineEntryEditorController from "./inline_entry_editor_controller"
application.register("inline-entry-editor", InlineEntryEditorController)

import TravelerController from "./traveler_controller"
application.register("traveler", TravelerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MonthController from "./month_controller"
application.register("month", MonthController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import SortableAccountsController from "./sortable_accounts_controller"
application.register("sortable-accounts", SortableAccountsController)

import AccountsOverviewTravelerController from "./accounts_overview_traveler_controller"
application.register("accounts-overview-traveler", AccountsOverviewTravelerController)

import MoldedCandleFormController from "./molded_candle_form_controller"
application.register("molded-candle-form", MoldedCandleFormController)

import MoldedCandleVariantFormController from "./molded_candle_variant_form_controller"
application.register("molded-candle-variant-form", MoldedCandleVariantFormController)

import MoldedCandleColorantFieldController from "./molded_candle_colorant_field_controller"
application.register("molded-candle-colorant-field", MoldedCandleColorantFieldController)

import MoldedCandlePriceController from "./molded_candle_price_controller"
application.register("molded-candle-price", MoldedCandlePriceController)

import MoldedCandleStockController from "./molded_candle_stock_controller"
application.register("molded-candle-stock", MoldedCandleStockController)

import MoldedCandleBatchLogItemController from "./molded_candle_batch_log_item_controller"
application.register("molded-candle-batch-log-item", MoldedCandleBatchLogItemController)

import MoldedCandleBatchPreparationController from "./molded_candle_batch_preparation_controller"
application.register("molded-candle-batch-preparation", MoldedCandleBatchPreparationController)

import MoldVariantWickController from "./mold_variant_wick_controller"
application.register("mold-variant-wick", MoldVariantWickController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import PerfumeSelectController from "./perfume_select_controller"
application.register("perfume-select", PerfumeSelectController)

import BlendFabricationController from "./blend_fabrication_controller"
application.register("blend-fabrication", BlendFabricationController)

import FabricationStockController from "./fabrication_stock_controller"
application.register("fabrication-stock", FabricationStockController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PerfumedCandleVariantFormController from "./perfumed_candle_variant_form_controller"
application.register("perfumed-candle-variant-form", PerfumedCandleVariantFormController)

import PerfumedCandleFormController from "./perfumed_candle_form_controller"
application.register("perfumed-candle-form", PerfumedCandleFormController)

import BatchLogItemController from "./batch_log_item_controller"
application.register("batch-log-item", BatchLogItemController)

import BatchPreparationController from "./batch_preparation_controller"
application.register("batch-preparation", BatchPreparationController)

import PerfumedCandleBatchSelectionController from "./perfumed_candle_batch_selection_controller"
application.register("perfumed-candle-batch-selection", PerfumedCandleBatchSelectionController)

import BlendBatchSelectionController from "./blend_batch_selection_controller"
application.register("blend-batch-selection", BlendBatchSelectionController)

import MoldFormController from "./mold_form_controller"
application.register("mold-form", MoldFormController)

import VariantFavoriteToggleController from "./variant_favorite_toggle_controller"
application.register("variant-favorite-toggle", VariantFavoriteToggleController)

import WaxMeltFormController from "./wax_melt_form_controller"
application.register("wax-melt-form", WaxMeltFormController)

import WaxMeltColorantFieldController from "./wax_melt_colorant_field_controller"
application.register("wax-melt-colorant-field", WaxMeltColorantFieldController)

// Generic controllers <3

import StockController from "./stock_controller"
application.register("stock", StockController)

import PriceController from "./price_controller"
application.register("price", PriceController)

import ObjectBatchFormController from "./object_batch_form_controller"
application.register("object-batch-form", ObjectBatchFormController)

import ObjectBatchItemController from "./object_batch_item_controller"
application.register("object-batch-item", ObjectBatchItemController)

import MaterialOrderAddItemController from "./material_order_add_item_controller"
application.register("material-order-add-item", MaterialOrderAddItemController)

import CategoryFormController from "./category_form_controller"
application.register("category-form", CategoryFormController)
